import { ListLabel } from '@shared/components/reusables/labels/components/list-label';
import { useLabelAction } from '@shared/components/reusables/labels/hooks/use-label-action';
import type { TLabel } from '@shared/types/label';
import leadApi from '@features/leads/services/lead-api';

interface LabelActionProps {
  id: number;
  labels: TLabel[];
}
export const LabelAction: React.FC<LabelActionProps> = ({ id, labels }) => {
  const { mutateAsync: updateLead } = leadApi.useUpdate();
  const {
    labels: stateLabels,
    toggleLabel,
    handleUpdateLabels,
  } = useLabelAction({
    initial: labels,
    onSave: (updated) => {
      const labelsPayload = updated
        ? updated.map((item) => item.id)
        : labels.map((item) => item.id);
      updateLead({
        labels: labelsPayload,
        id,
      });
    },
  });

  return (
    <ListLabel
      data={stateLabels}
      onChange={toggleLabel}
      handleUpdateLabelsSave={handleUpdateLabels}
    />
  );
};
